import { PublicAgendaModuleSchema } from "../../models/agendaModule.schema";

export const AgendaModuleControllerResponseSchema = {
  listPublicAgendaModules: PublicAgendaModuleSchema.array(),

  getPublicAgendaModule: PublicAgendaModuleSchema.nullable(),
};
